import { Component, inject } from '@angular/core';
import { RoadCargoTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RoadCargoTypeCreateDto,
  RoadCargoTypeDto,
  RoadCargoTypeExcelDownloadDto,
  RoadCargoTypeUpdateDto,
} from '../proxy/controlling/dtos/road-cargo-type';
import { ROADCARGOTYPE_CONFIG, ROADCARGOTYPE_FIELDS } from './road-cargo-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-road-cargo-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RoadCargoTypeService, ConfirmationService],
  templateUrl: './road-cargo-type.html',
  styleUrl: './road-cargo-type.scss',
})
export class RoadCargoType extends BaseCrudComponent<
  RoadCargoTypeDto,
  RoadCargoTypeCreateDto,
  RoadCargoTypeUpdateDto,
  RoadCargoTypeExcelDownloadDto
> {
  service = inject(RoadCargoTypeService);
  config = ROADCARGOTYPE_CONFIG;
  fields = ROADCARGOTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RoadCargoTypeDto): RoadCargoTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RoadCargoType';
  }
}
